(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-redux/assets/sport-event-reducer.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-redux/assets/sport-event-reducer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _RTK = RTK,
  createReducer = _RTK.createReducer;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.actions,
  fetchMatchInfo = _svs$components$sport.fetchMatchInfo,
  fetchMatchData = _svs$components$sport.fetchMatchData;
const normalizeProviders = svs.components.sport.matchInfoRedux.normalizeProviders;
const ReducerState = svs.components.sport.tipsenShared.ReducerState;
const _svs$components$sport2 = svs.components.sport.drawsRedux.actions,
  loadOpenedDrawsByEngine = _svs$components$sport2.loadOpenedDrawsByEngine,
  loadDrawByProduct = _svs$components$sport2.loadDrawByProduct,
  updateDraw = _svs$components$sport2.updateDraw;
const getSportEventFromMatchId = (state, matchId) => {
  if (!state[matchId]) {
    state[matchId] = {
      matchId,
      lastFetched: null,
      eventState: ReducerState.Init,
      oddsState: ReducerState.Init,
      dataState: ReducerState.Init
    };
  }
  return state[matchId];
};
const addReducerStateFields = (state, sportEvents) => {
  const _sportEvents = {};
  if (sportEvents) {
    const keys = Object.keys(sportEvents);
    keys.forEach(matchId => {
      const match = getSportEventFromMatchId(state, matchId);
      _sportEvents[matchId] = _objectSpread(_objectSpread(_objectSpread({}, match), sportEvents[matchId]), {}, {
        dataState: ReducerState.Done,
        eventState: ReducerState.Done,
        oddsState: ReducerState.Done
      });
    });
  }
  return _sportEvents;
};
const sportEventReducer = createReducer({}, builder => {
  builder.addCase(fetchMatchInfo.pending, (state, action) => {
    const matchId = action.meta.arg.matchId;
    const sportEvent = getSportEventFromMatchId(state, matchId);
    sportEvent.oddsState = ReducerState.Pending;
    sportEvent.eventState = ReducerState.Pending;
  }).addCase(fetchMatchInfo.rejected, (state, action) => {
    const matchId = action.meta.arg.matchId;
    const sportEvent = getSportEventFromMatchId(state, matchId);
    sportEvent.oddsState = ReducerState.Rejected;
    sportEvent.eventState = ReducerState.Rejected;
  }).addCase(fetchMatchInfo.fulfilled, (state, action) => {
    var _action$meta$enhanche;
    const matchId = action.meta.arg.matchId;
    const sportEvent = getSportEventFromMatchId(state, matchId);
    const _action$payload = _slicedToArray(action.payload, 2),
      eventInfo = _action$payload[0],
      odds = _action$payload[1];
    sportEvent.eventState = eventInfo.error ? ReducerState.Rejected : ReducerState.Done;
    sportEvent.oddsState = odds.error ? ReducerState.Rejected : ReducerState.Done;
    sportEvent.lastFetched = (_action$meta$enhanche = action.meta.enhanchedData) === null || _action$meta$enhanche === void 0 ? void 0 : _action$meta$enhanche._svsTimestamp;
    if (sportEvent.eventState === ReducerState.Done) {
      for (const _ref of Object.entries(eventInfo.match)) {
        var _ref2 = _slicedToArray(_ref, 2);
        const prop = _ref2[0];
        const value = _ref2[1];
        sportEvent[prop] = value;
      }
    }
  }).addCase(fetchMatchData.pending, (state, action) => {
    const matchId = action.meta.arg.matchId;
    const match = getSportEventFromMatchId(state, matchId);
    match.dataState = ReducerState.Pending;
  }).addCase(fetchMatchData.rejected, (state, action) => {
    const matchId = action.meta.arg.matchId;
    const match = getSportEventFromMatchId(state, matchId);
    match.dataState = ReducerState.Rejected;
  }).addCase(fetchMatchData.fulfilled, (state, action) => {
    const matchId = action.meta.arg.matchId;
    const match = getSportEventFromMatchId(state, matchId);
    const matchData = action.payload;
    if (matchData.error) {
      match.dataState = ReducerState.Rejected;
    } else {
      var _matchData$sportEvent;
      const providerIds = normalizeProviders((_matchData$sportEvent = matchData.sportEvent) === null || _matchData$sportEvent === void 0 ? void 0 : _matchData$sportEvent.providerIds);
      match.externalId = _objectSpread({}, providerIds);
      match.providerIds = providerIds;
      match.dataState = ReducerState.Done;
    }
  }).addCase(loadOpenedDrawsByEngine.fulfilled, (state, action) => {
    const sportEvents = addReducerStateFields(state, action.payload.SportEvents);
    Object.assign(state, sportEvents);
  }).addCase(updateDraw, (state, action) => {
    var _action$meta;
    if ((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.isLightUpdate) {
      return state;
    }
    const sportEvents = addReducerStateFields(state, action.payload.SportEvents);
    Object.assign(state, sportEvents);
  }).addCase(loadDrawByProduct.fulfilled, (state, action) => {
    const sportEvents = addReducerStateFields(state, action.payload.draws.SportEvents);
    Object.assign(state, sportEvents);
  });
});
setGlobal('svs.components.sportinfo.matchInfoRedux.sportEventReducer', sportEventReducer);

 })(window);